import moment from 'moment'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Row } from '@/components/form'
import LabeledDetail from '@/components/labeled-detail'
import Panel from '@/components/panel'
import ListingInfo from '@/features/Listing/listing-info'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints, colors, fontWeights } from '@/styles'

const Wrapper = styled.div`
  > div:first-of-type {
    border: 1px solid ${colors.lightGrey};
    border-bottom: none;
    background: ${colors.white};
    padding: 30px;
    margin-top: 0;
  }
  > section {
    padding-top: 0;
    border-top: none;
  }
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0 !important;
    border: none !important;
    > div:first-of-type {
      padding: 0;
      width: 100%;
      background: ${colors.white};
      border-radius: 16px 16px 0 0;
      p {
        font-size: 14px;
        font-weight: ${fontWeights.regular};
        padding: 30px 30px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: calc(100% - 20px);
      }
    }
    > section {
      padding-top: 30px;
    }
  }
`

const Separator = styled.div`
  height: 1px;
  background: ${colors.mediumGrey};
  margin-bottom: 30px;
`

const StyledPanel = styled(Panel)`
  border-radius: 0 0 16px 16px;
`

const InfoView = ({ listingId: listingIdInitial, application, ...rest }) => {
  const { t } = useTranslation()
  const moveInDate = moment(application.move_in_date).format('YYYY-MM-DD')
  const listingId = listingIdInitial ?? application?.listing_id
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const hideImage = displayMobile
  return (
    <Wrapper>
      <ListingInfo {...rest} hideInfo={displayMobile} hideImage={hideImage} listingId={listingId} />
      <StyledPanel hSpace={30} vSpace={30}>
        {!displayMobile && <Separator />}
        <Row gutter="0">
          <LabeledDetail
            label={t('r.application.create.move_in_date.label', 'Desired move-in date')}
            value={
              application.move_in_date
                ? moveInDate
                : t('r.application.create.as_soon_as_possible.label', 'As soon as possible')
            }
            width="50%"
          />
        </Row>
      </StyledPanel>
    </Wrapper>
  )
}

export default InfoView
